/**
 * Created by Tom.Jaeschke on 7/26/2017.
 */
export interface FileKeyPairing {
  File: any;
  Key: number;
}
